import DisabledScanner from "./DisabledScanner";

export default DisabledScanner;
